import { useRouter } from "next/router";
import type { FunctionComponent } from "react";
import { SignUpPopup } from "scmp-sdk";

import { useRouterReplaceWithSanitizedKeys } from "shared/lib/router";

import { SanitizedUrlKeys, SignUpCompleteUrlKey } from "./consts";
import { useNewsletterSignUpRedirect } from "./hooks";

export const SignUpActionRedirect: FunctionComponent = () => {
  const { pathname, query } = useRouter();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { setShowPopup, showPopup } = useNewsletterSignUpRedirect();

  return (
    <SignUpPopup
      isShow={showPopup}
      onClose={() => {
        setShowPopup(false);
        // Move the replace to here is because we still need the query string to toggle the visibility of this component
        void replace(
          SanitizedUrlKeys,
          { pathname, query },
          {
            shallow: true,
          },
          {
            [SignUpCompleteUrlKey]: "true",
          },
        );
      }}
    />
  );
};

SignUpActionRedirect.displayName = "SignUpActionRedirect";
